module.exports = __webpack_public_path__ + "img/slider3.93874424.jpg";